import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ModelToFormDataService
{
    convertModelToFormData(model: any, form: FormData | null = null, namespace = ''): FormData
    {
        const formData = form || new FormData();
        let formKey: any;

        for (const propertyName in model)
        {
            if (!model.hasOwnProperty(propertyName) || !model[propertyName])
            {
                continue;
            }

            formKey = namespace ? `${namespace}[${propertyName}]` : propertyName;

            if (model[propertyName] instanceof Date)
            {
                formData.append(formKey, model[propertyName].toISOString());
            }
            else if (model[propertyName] instanceof Array)
            {
                model[propertyName].forEach((element: any, index: any) =>
                {
                    const tempFormKey = `${formKey}[${index}]`;

                    if (typeof element === 'object')
                    {
                        this.convertModelToFormData(element, formData, tempFormKey);
                    }
                    else
                    {
                        formData.append(tempFormKey, element.toString());
                    }
                });
            }
            else if (model[propertyName] instanceof Blob)
            {
                formData.append(formKey, model[propertyName]);
            }
            else if (typeof model[propertyName] === 'object' && !(model[propertyName] instanceof File))
            {
                this.convertModelToFormData(model[propertyName], formData, formKey);
            }
            else
            {
                formData.append(formKey, model[propertyName].toString());
            }
        }

        return formData;
    }
}
